import { IsNotEmpty, IsString } from 'class-validator';

export class SetAddressDto {
	@IsString()
	@IsNotEmpty({ message: 'Please enter a valid address' })
	public addressName?: string;

	@IsString()
	@IsNotEmpty()
	public addressLat: string;

	@IsString()
	@IsNotEmpty()
	public addressLng: string;
}
